module.exports = __webpack_public_path__ + "img/janflow-header.b80126ca.png";